import {
  AppCard,
  PageContainer,
} from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ForbiddenError } from "../../../../errors/ForbiddenError";
import { NewTermsExceptionForm } from "./-internal_components/NewTermsExceptionForm";

const NewTermsException: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer showBackButton title={t("termsExceptions.new.title")}>
      <AppCard>
        <NewTermsExceptionForm />
      </AppCard>
    </PageContainer>
  );
};

export const Route = createFileRoute(
  "/_private/vsupplierregistration/terms_exceptions/new",
)({
  beforeLoad({ context }) {
    if (context.auth.user?.roles_names.includes("Terms Exception - Create")) {
      return;
    }

    throw new ForbiddenError();
  },
  component: NewTermsException,
});
